import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'
import isEmpty from 'lodash/isEmpty'

export default {
  namespaced: true,

  state: {
    loading: false,
    dialog: false,
    dialog_campaign: false,
    dialog_deposit: false,
    data: {
      dollar: 0,
      vidCents: 0
    },
    paymentHistory: [],
    tracks: [],
    campaigns: [],
    campaign: {
      id: null,
      name: ''
    }
  },

  mutations: {
    setDialog(state, payload) {
      state.dialog = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setData(state, payload) {
      state.data = payload
    },
    setPaymentHistory(state, payload) {
      state.paymentHistory = payload
    },
    setDialogCampaign(state, payload) {
      state.dialog_campaign = payload
    },
    setCampaign(state, payload) {
      state.campaign = payload
    },
    setCampaigns(state, payload) {
      state.campaigns = payload
    },
    setCampaignDeposit(state, status) {
      state.dialog_deposit = status
    },
    setTracks(state, payload) {
      state.tracks = payload
    }
  },

  actions: {
    getBalance({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('balance')
        .then(r => {
          commit('setLoading', false)
          commit('setData', r.data.data)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    setpayment({ commit, dispatch }, payment) {
      axios.label
        .post('payment', {
          amount: payment.amount,
          payment_method_nonce: payment.nonce
        })
        .then(() => {
          dispatch('getBalance')
          dispatch('getPaymentHistory')
          commit('setLoading', false)
          commit('setDialog', false)
        })
        .catch(err => {
          commit('setLoading', false)
          commit('setDialog', false)
          if (err.response.data && err.response.data.response.message) {
            Message({
              type: 'error',
              message: err.response.data.response.message
            })
          }
        })
    },
    getPaymentHistory({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('paymenthistory')
        .then(r => {
          commit('setLoading', false)
          commit('setPaymentHistory', r.data.data)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },
    createCampaign({ commit, dispatch, state }) {
      axios.label
        .post(`campaign/create`, {
          name: state.campaign.name
        })
        .then(() => {
          commit('setDialogCampaign', false)
          dispatch('readCampaign')
        })
        .catch(() => {
          commit('setDialogCampaign', false)
        })
    },
    readCampaign({ dispatch, commit }) {
      commit('setLoading', true)
      axios.label
        .get('campaign')
        .then(r => {
          let campaign = r.data.data,
            temp = {}
          commit('setLoading', false)
          commit('setCampaigns', campaign)

          temp = this.state.labelTrackVidCents.active_campaign
          commit('labelTrackVidCents/setActiveCampaign', {}, { root: true })
          commit('artistTrackVidCents/setTracks', [], { root: true })
          if (!isEmpty(temp)) {
            for (let i = 0; i < campaign.length; i++) {
              if (campaign[i].id == temp.id) {
                temp = campaign[i]
                break
              }
            }

            commit('labelTrackVidCents/setActiveCampaign', temp, { root: true })
            dispatch('labelTrackVidCents/readTracks', null, { root: true })
          } else if (campaign.length > 0) {
            commit('labelTrackVidCents/setActiveCampaign', campaign[0], {
              root: true
            })
            dispatch('labelTrackVidCents/readTracks', null, { root: true })
          }
        })
        .catch(() => {
          commit('setCampaigns', [])
          commit('labelTrackVidCents/setActiveCampaign', null, { root: true })
          dispatch('labelTrackVidCents/readTracks', null, { root: true })
          commit('setLoading', false)
        })
    },
    depositCampaign({ state, dispatch, commit }, deposit) {
      MessageBox.confirm(
        `You will deposit ${deposit} VC to ${state.campaign.name} campaign. Continue?`,
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }
      )
        .then(() => {
          axios.label
            .post(`campaign/${state.campaign.id}/deposit/${deposit}`)
            .then(() => {
              commit('setCampaignDeposit', false)
              dispatch('readCampaign')
              dispatch('getBalance')
            })
            .catch(err => {
              if (err.response.data && err.response.data.response.message) {
                Message({
                  type: 'error',
                  message: err.response.data.response.message
                })
              }
            })
        })
        .catch(() => {
          Message({
            type: 'info',
            message: 'Deposit cancelled'
          })
        })
    },
    getTracks({ commit }) {
      commit('setLoading', true)
      axios.label
        .get('campaign/track')
        .then(r => {
          commit('setLoading', false)
          commit('setTracks', r.data.data)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    }
  }
}
